<template>
  <div>
    <div class="row ml-1 mb-4">
      <div class="col">
        <div class="block-spacing">
          <strong class="d-block">Servicio:</strong>
          <span>{{ serviceTypeTitle }}</span>
        </div>
      </div>
      <div class="col">
        <span>
          <b>¿Es ofrecido por Remedio Provisional?</b>
        </span>
        <ValidationProvider
          v-slot="{ errors }"
          name="¿Es ofrecido por Remedio Provisional?"
          rules="required"
        >
          <div class="input-group">
            <input
              id="provisionalRemedyYes"
              v-model="provisionalRemedyValue"
              type="radio"
              class="hidden"
              name="provisionalRemedy"
              :value="'S'"
              :disabled="disabledAll"
              @click="onChangeRemedy('S', $event)"
            />
            <label class="entry" for="provisionalRemedyYes">
              <div class="circle" />
              <div class="entry-label">Sí</div>
            </label>
            <input
              id="provisionalRemedyNo"
              v-model="provisionalRemedyValue"
              type="radio"
              class="hidden"
              name="provisionalRemedy"
              :value="'N'"
              :disabled="disabledAll"
              @click="onChangeRemedy('N', $event)"
            />
            <label class="entry" for="provisionalRemedyNo">
              <div class="circle" />
              <div class="entry-label">No</div>
            </label>
            <div v-if="provisionalRemedyValueNew !== null" class="highlight" />
            <Error
              v-if="disabledAll ? '' : errors[0]"
              variant="no-border mt-n2"
              message="Favor de contestar si el servicio es ofrecido por remedio provisional."
            />
          </div>
        </ValidationProvider>

        <div class="modality-align">
          <ValidationProvider
            v-slot="{ errors }"
            name="Modalidad"
            rules="required"
          >
            <CustomDropDown
              v-model="selectedModality"
              required
              :options="modalityList"
              fieldkey="id"
              fieldname="name"
              label="Modalidad:"
              placeholder="Seleccione"
              class="block-spacing"
              :error="disabledAll ? '' : errors[0]"
              :custom-error-msg="
                disabledAll ? '' : 'Seleccione la modalidad del servicio.'
              "
              :disabled="disabledAll"
              @input="$emit('on-change-modality', { ...selectedModality })"
            />
          </ValidationProvider>
        </div>
      </div>
      <div class="col">
        <ValidationProvider v-slot="{ errors }" name="Duración" rules="required">
          <CustomDropDown
            v-model="selectedDuration"
            :options="durationList"
            fieldkey="id"
            fieldname="name"
            label="Duración:"
            placeholder="Seleccione"
            class="block-spacing"
            :error="disabledAll ? '' : errors[0]"
            :custom-error-msg="
              disabledAll ? '' : 'Seleccione la duración del servicio.'
            "
            :disabled="disabledAll"
            @input="$emit('on-change-duration', { ...selectedDuration })"
          />
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="Frecuencia"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedFrequency"
            :options="frequencyList"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            label="Frecuencia:"
            class="block-spacing"
            :error="disabledAll ? '' : errors[0]"
            :custom-error-msg="
              disabledAll ? '' : 'Seleccione la frecuencia del servicio.'
            "
            :disabled="disabledAll"
            @input="$emit('on-change-frequency', { ...selectedFrequency })"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row ml-1 mb-4">
      <div class="col mt-2">
        <label class="input-label">Razón de Servicio:</label>
        <ValidationProvider
          v-slot="{ errors }"
          name="serviceReason"
          :rules="'required'"
        >
          <CustomTextArea
            :id="'serviceReason'"
            v-model="therapyServiceReason"
            style="width: 100%"
            :maxlength="3000"
            placeholder="Escribe un comentario"
            :classes="['eq-field', 'text-right']"
            :rows="5"
            :error="errors[0]"
            :custom-error-msg="'Razón del servicio es requerido para continuar el proceso.'"
            :disabled="disabledAll"
            @input="$emit('on-change-service-reason', therapyServiceReason )"
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { CustomDropDown } from '@/components/common';
import Error from '@/components/common/Error';
import CustomTextArea from '@/components/common/CustomTextArea';

export default {
  name: 'TherapyService',
  components: {
    ValidationProvider,
    CustomDropDown,
    Error,
    CustomTextArea
  },
  data() {
    return {
      provisionalRemedyValue: null,
      selectedModality: null,
      selectedDuration: null,
      selectedFrequency: null,
      therapyServiceReason: null
    };
  },
  computed: {
    visualControlCode: () => 2,
    provisionalRemedyValueNew() {
      return this.provisionalRemedyValue === 'U'
        ? null
        : this.provisionalRemedyValue;
    },
  },
  props: {
    modalityList: {
      type: Array,
      default: () => [],
    },
    durationList: {
      type: Array,
      default: () => [],
    },
    frequencyList: {
      type: Array,
      default: () => [],
    },
    serviceTypeTitle: {
      type: String,
      default: () => 'Terapia de Habla',
    },
    disabledAll: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    onChangeRemedy(value) {
      this.provisionalRemedyValue = value;
      this.$emit('on-change-remedy', value);
    },
  }
};
</script>

<style scoped src="@/assets/css/component/radio-button.css" />
<style scoped>
.block-spacing {
  margin-bottom: 30px;
}

.block-spacing >>> .invalid {
  position: absolute;
  font-size: 13px;
  margin-left: 5px;
}

.exclamation-icon {
  color: #ff5b5c;
  margin-left: 10px;
  margin-top: 2px;
}

.modality-align {
  margin-top: 36px;
}
</style>
